import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router-dom';

import getEventsList from '../../../api/graphql/queries/getEventsList';
import postAddEvent from '../../../api/graphql/mutations/postAddEvent';
import postEditEvent from '../../../api/graphql/mutations/postEditEvent';
import postDeleteEvent from '../../../api/graphql/mutations/postDeleteEvent';

import getPostsByCategory from '../../../api/graphql/queries/getPostsByCategory';
import artistSetsByArtistSetSlugs from '../../../api/graphql/queries/artistSetsByArtistSetSlugs';

import LoadIcon from '../../LoadIcon';
import Filter from '../../Tabs/Filter';
import EventForm from './EventForm';
import Form from './Form';
import Modal from '../../Modal/Modal';
import slugify from '../../../utils/slugify';
import DataTable from '../../Table/DataTable';
import eventColumns from './eventColumns';

const DEFAULT_ROWS_PER_PAGE = 50;

const itemName = 'eventSlugName';

const debounce = (func, delay) => {
  let inDebounce;
  return (...args) => {
    const context = this;
    clearTimeout(inDebounce);
    inDebounce = setTimeout(() => func.apply(context, args), delay);
  };
};

class EventContainer extends Component {
  state = {
    filterText: '',
    page: 0,
    total: 0,
    rowsPerPage: DEFAULT_ROWS_PER_PAGE,
    sorting: ['createdAt', -1],
    isCreateModalOn: false,
    isDisplayModalOn: false,
    isModifyModalOn: false,
    isDeleteModalOn: false,
    formOutput: {},
    currItemData: [],
    toggleDeleteInfoScreen: false,
    filteredItems: [],
    isLoading: true,
    canItemBeDeleted: true,
    eventSlugNames: [],
    routePosts: [],
    venuesFromArtistSet: [],
  };

  _isMounted=false;


  // A new search starts again at the first page: staying on page 7 of the
  // previous result set would land the editor on an empty screen.
  updateSearch = debounce(async (val) => {
    this.setState({ filterText: val }, () => this.loadPage(0));
  }, 500);

  /*
  One page of events. The list used to render nothing until four characters were
  typed, because the query returned the whole collection and there was nothing
  else holding it back; it pages now, so a search is a filter rather than a
  precondition.

  getEvents() below deliberately stays unpaged: it needs every event to work out
  which ones cannot be their own sub-event, and paging is opt-in precisely so
  that call keeps returning the whole list.
  */
  loadPage = async (page = 0) => {
    const { filterText, rowsPerPage, sorting } = this.state;
    this.setState({ isLoading: true });
    const result = await getEventsList((filterText || '').toLowerCase(), {
      limit: rowsPerPage,
      offset: page * rowsPerPage,
      sortField: sorting[0],
      sortOrder: sorting[1],
    });
    if (!this._isMounted) return;
    this.setState({
      filteredItems: (result && result.events) || [],
      total: (result && result.total) || 0,
      page,
      isLoading: false,
    });
  };

  componentDidMount = () => {
    this._isMounted = true;
    this.getToursPosts();
    this.getEvents();
    this.loadPage(0);
  };

  // The table owns page size and sort order; both reset to the first page,
  // because a different page size or order makes the old offset meaningless.
  setRowsPerPage = (rowsPerPage) => {
    this.setState({ rowsPerPage }, () => this.loadPage(0));
  };

  setSorting = (sorting) => {
    this.setState({ sorting }, () => this.loadPage(0));
  };

  componentWillUnmount() {
    this._isMounted = false;
  }

  getToursPosts = () => {
    getPostsByCategory('tours')
      .then((res) => {
        if (res) {
          const { posts } = res;
          const routePosts = posts.map(post => post.slugName);
          if (this._isMounted) {
            this.setState({
              routePosts,
            });
          }
        }
      })
      .catch(err => console.log(err, ' => getPostsByCategory'));
  };

  getEvents = async () => {
    const { history } = this.props;
    const { filterText } = this.state;
    this.setState({ isLoading: true });

    const eventsData = await getEventsList();
    if (eventsData) {
      if (eventsData.isAuth) {
        if (filterText) {
          const eventSlugNames = eventsData.events.map(i => i.eventSlugName);
          // Logic to prevent users from adding as subevents, events that have themselves as parents. Like if Primavera Sound had Primavera Als Barris as subevent and while modifying Primavera Als Barris we were trying to add Primavera Sound as subevent.
          const eventSlugNamesWithSubEvents = {};

          eventsData.events.forEach((i) => {
            if (i.eventSlugName && i.eventsArray && i.eventsArray.length) {
              i.eventsArray.forEach((item) => {
                if (item !== null) {
                  eventSlugNamesWithSubEvents[i.eventSlugName] = item.toLowerCase();
                }
              });
            }
            return null;
          });
          if (this._isMounted) {
            this.setState({
              eventSlugNames,
              eventSlugNamesWithSubEvents,
            });
          }
        } else {
          const eventSlugNames = eventsData.events.map(i => i.eventSlugName);
          // Logic to prevent users from adding as subevents, events that have themselves as parents. Like if Primavera Sound had Primavera Als Barris as subevent and while modifying Primavera Als Barris we were trying to add Primavera Sound as subevent.
          const eventSlugNamesWithSubEvents = {};

          eventsData.events.forEach((i) => {
            if (i.eventSlugName && i.eventsArray && i.eventsArray.length) {
              i.eventsArray.forEach((item) => {
                if (item !== null) {
                  eventSlugNamesWithSubEvents[i.eventSlugName] = item.toLowerCase();
                }
              });
            }
            return null;
          });
          if (this._isMounted) {
            this.setState({
              eventSlugNames,
              eventSlugNamesWithSubEvents,
            });
          }
        }
      } else {
        console.log('getEventsList - User authentication failed!');
        history.push('/login');
      }
    } else {
      console.log('eventsData = null');
    }
  };


  handleClick = (action, item) => {
    console.log(`And the action is: ${action}, for item ${item}`);
    this.toggleModifyModal(item);
  };

  toggleModifyModal = (item) => {
    const { filteredItems } = this.state;
    const currItemData = filteredItems.filter(el => el[itemName] === item);
    if (currItemData && item) {
      this.handleArtistSetToVenue(currItemData[0].artistSets);
    }
    this.setState({
      isModifyModalOn: !this.state.isModifyModalOn,
      currItemData,
    });
  };

  toggleDeleteInfoScreen = () => this.setState({ toggleDeleteInfoScreen: !this.state.toggleDeleteInfoScreen });

  formOutput = (formOutput, action) => {
    console.log('formOutput', formOutput, action);

    const { history } = this.props;
    const { filterText } = this.state;

    if (action === 'create') {
      postAddEvent({ ...formOutput }).then((postAddEventResultData) => {
        if (postAddEventResultData) {
          if (postAddEventResultData.isAuth) {
            if (postAddEventResultData.isAdded) {
              console.log(`postAddEvent - Successfully added event with eventSlugName ${postAddEventResultData.eventSlugName}!`);
              this.updateSearch(filterText || '');
              this.setState({
                isModifyModalOn: !this.state.isModifyModalOn,
              });
            } else {
              console.log('postAddEvent - Failed to add event! Missing fields or eventSlugName exists');
            }
          } else {
            console.log('postAddEvent - User authentication failed!');
            history.push('/login');
          }
        } else {
          console.log('postAddEventResultData = null');
        }
      });
    } else if (action === 'modify') {
      postEditEvent({ ...formOutput }).then((postEditEventResultData) => {
        if (postEditEventResultData) {
          if (postEditEventResultData.isAuth) {
            if (postEditEventResultData.isEdited) {
              console.log(`postEditEvent - Successfully edited event with eventSlugName ${postEditEventResultData.eventSlugName}!`);
              this.setState({
                isModifyModalOn: !this.state.isModifyModalOn,
              });
              this.updateSearch(filterText || '');
            } else {
              console.log('postEditEvent - Failed to edit event! Missing fields or eventSlugName does not exist');
            }
          } else {
            console.log('postEditEvent - User authentication failed!');
            history.push('/login');
          }
        } else {
          console.log('postEditEventResultData = null');
        }
      });
    } else {
      console.log('Incorrect action at the time of');
    }
  };

  handleDelete = (itemId, itemSlug) => {
    console.log(`the item ${itemSlug} will be deleted`);

    const { history } = this.props;

    const formData = {
      id: itemId,
      eventSlugName: slugify(itemSlug.toLowerCase()),
    };

    postDeleteEvent({ ...formData }).then((postDeleteEventResultData) => {
      if (postDeleteEventResultData) {
        if (postDeleteEventResultData.isAuth) {
          if (postDeleteEventResultData.isDeleted) {
            const { filterText } = this.state;
            console.log(`postDeleteEvent - Successfully deleted event with eventSlugName ${postDeleteEventResultData.eventSlugName}!`);
            this.toggleDeleteInfoScreen();
            this.setState({ canItemBeDeleted: true, isModifyModalOn: !this.state.isModifyModalOn });
            this.updateSearch(filterText || '');
          } else {
            if (postDeleteEventResultData.isUsed.eventSlugNames.length === 0) {
              console.log('postDeleteEvent - Failed to delete event! Event does not exist.');
            } else if (postDeleteEventResultData.isUsed.eventSlugNames.length > 0) {
              console.log(`postDeleteEvent - Failed to delete event! Event is used in eventSlugNames: ${postDeleteEventResultData.isUsed.eventSlugNames}`);
              this.toggleDeleteInfoScreen();
              this.setState({ canItemBeDeleted: false });
            }
          }
        } else {
          console.log('postDeleteEvent - User authentication failed!');
          history.push('/login');
        }
      } else {
        console.log('postDeleteEventResultData = null');
      }
    });
  };

  // Find venues linked to the selected artistSets (the starting point in the logic is artist set and from there we will get venues, which will not be modifiable)

  handleArtistSetToVenue = async (artistSetsArr = []) => {
    if (artistSetsArr.length === 0) {
      this.setState({ venuesFromArtistSet: [] });
    } else {
      try {
        const artistSetsResultFromQuery = await artistSetsByArtistSetSlugs(artistSetsArr);
        if (artistSetsResultFromQuery && artistSetsResultFromQuery.length) {
          const venuesFromArtistSets = artistSetsResultFromQuery.map(artistSet => artistSet.venueSlugName);
          const venuesFromArtistSetsWODuplicates = [...new Set(venuesFromArtistSets)];
          this.setState({ venuesFromArtistSet: venuesFromArtistSetsWODuplicates });
        } else {
          this.setState({ venuesFromArtistSet: [] });
        }
      } catch (error) {
        console.log('artistSetData = null', error);
      }
    }
  };

  // as we handle the artistSet to venue in the container (where the query is) we need to clear it when the tab is closed

  clearArtistSetToVenue = () => {
    this.setState({
      venuesFromArtistSet: [],
    });
  };

  render() {
    const {
      filterText, isDisplayModalOn, isDeleteModalOn, isModifyModalOn, currItemData, canItemBeDeleted, toggleDeleteInfoScreen, filteredItems, isLoading, eventSlugNames, eventSlugNamesWithSubEvents, routePosts, venuesFromArtistSet, page, total, rowsPerPage, sorting,
    } = this.state;
    return (
      <div className="w-full bg-white">
        <div className="flex justify-between mb-4">
          <span className="text-americaMonoBold text-26">Events</span>
          <button
            type="button"
            className="font-americaMonoBold text-xs pr-6 pl-8 py-2 rounded-full bg-black text-white uppercase h-10 flex items-center"
            onClick={() => {
              this.handleClick('create');
            }}
          >
            Create Event
            {' '}
            <span className="font-icon icon-add-button text-white font-black pl-3 text-base" />
          </button>
        </div>
        {isModifyModalOn && (
          <Modal handleClick={this.handleClick} type="modify">
            <Form
              saveEvent={this.formOutput}
              formInput={currItemData[0]}
              handleDelete={this.handleDelete}
              canItemBeDeleted={canItemBeDeleted}
              toggleDeleteInfoScreen={toggleDeleteInfoScreen}
            />
          </Modal>
        )}
        <div className="mt-4">
          <Filter updateSearch={this.updateSearch} searchText={filterText} placeholder="Search events by name or slug" />
          {isLoading && <LoadIcon />}
          {!isLoading && (filteredItems && filteredItems.length
            ? (
              <DataTable
                tableData={filteredItems}
                columns={eventColumns(this.handleClick)}
                total={total}
                page={page}
                setPage={this.loadPage}
                rowsPerPage={rowsPerPage}
                setRowsPerPage={this.setRowsPerPage}
                sorting={sorting}
                setSorting={this.setSorting}
              />
            )
            : <div>{filterText ? 'No events match that search' : 'No events yet'}</div>)}
        </div>
      </div>
    );
  }
}

EventContainer.propTypes = {
  history: PropTypes.shape().isRequired,
};

export default withRouter(EventContainer);
